import { RouteItem } from '@eastcoal/router/types/route'

import { MY_MEMBER_LIST_PAGE_UUID } from './uuid'

export const myMemberRoute: RouteItem = {
  title: '我的会员',
  path: '/member/list/my',
  uuid: MY_MEMBER_LIST_PAGE_UUID,
  Component: () => import('./index')
}
